import dynamic from 'next/dynamic'
import * as S from './styles'
import { useContext } from 'react'
import SectionThemeContext from '@contexts/SectionTheme'
import { Container } from '@/atoms/Grid'

const BannerCarousel = dynamic(() => import('@/molecules/BannerCarousel'))

const Slider = ({ slides, theme }) => {
  const colorScheme = useContext(SectionThemeContext) || theme
  return (
    <S.Slider>
      <Container>
        <BannerCarousel
          items={slides}
          colorScheme={colorScheme}
        />
      </Container>
    </S.Slider>
  )
}

export default Slider
